<div class="dialog-header-container d-flex align-items-center justify-content-between p-3 border-bottom bg-white">
  <h2 mat-dialog-title class="m-0 fs-5 fw-bold text-dark">
    @if (inputData.groupe_id) {
      Distribution Groupe {{ inputData.title }}
    } @else {
      Distribution Bureau {{ inputData.title }}
    }
  </h2>
  <button mat-icon-button mat-dialog-close (click)="resetForm()" aria-label="Fermer">
    <mat-icon class="text-muted">close</mat-icon>
  </button>
</div>

<mat-dialog-content [formGroup]="distForm" class="p-4 bg-white custom-dialog-content">
  <div class="d-flex flex-column gap-3">

    <!-- Sélection Compagnie -->
    <mat-form-field appearance="outline" class="w-100 input-with-action">
      <mat-label>Compagnie</mat-label>
      <input matInput type="text" formControlName="compagnie_name" placeholder="">
      <button type="button" mat-icon-button matSuffix color="primary" matTooltip="Sélectionner un collaborateur"
              (click)="selectCompagnie(); $event.stopPropagation()">
        <mat-icon>ink_selection</mat-icon>
      </button>
      @if (distForm.get('compagnie_name')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
    </mat-form-field>

    <!-- Sélection Type de Document -->
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Type de Document</mat-label>
      <mat-select formControlName="type" (valueChange)="onSelectedType($event)">
        <mat-option disabled="">Choisir le type de doc.</mat-option>
        @for (item of typeDocList; track $index) {
          <mat-option [value]="item.type">{{ item.type }}</mat-option>
        }
      </mat-select>
      @if (distForm.get('owner')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
    </mat-form-field>

    <!-- Section des Lots Disponibles -->
    <div class="w-100 mt-2">
      <span class="d-block small fw-bold text-secondary text-uppercase tracking-wider mb-3">
        Lot(s) de document(s) disponible(s)
      </span>

      <div class="d-flex flex-column gap-4">
        @for (item of currentDistribution; track $index) {
          <div class="lot-section-card p-3 rounded-3 border bg-light position-relative">
            
            <div class="d-flex align-items-center mb-3 text-primary border-bottom pb-2">
              <mat-icon class="me-2 fs-5 d-flex align-items-center justify-content-center">arrow_circle_right</mat-icon>
              <span class="fw-semibold small-title">Lot N° {{ $index + 1 }} : {{ item.reste }} document(s)</span>
            </div>

            <div class="row g-2">
              <div class="col-12 col-sm-4.5 col-md-4.5">
                <mat-form-field appearance="outline" class="w-100 background-white-field">
                  <mat-label>Quantité</mat-label>
                  <input matInput type="number" #input [(ngModel)]="stocks()[$index].qte" [ngModelOptions]="{standalone: true}"
                         (input)="generateDocuments(item.id, input.value, item.attestation_range, item.carte_rose_range, $index)"
                         [max]="item.reste">
                  <mat-hint [class.text-danger]="maxQteValue((input.value), item.reste)">MAX : {{ item.reste }}</mat-hint>
                </mat-form-field>
              </div>

              <div class="col-12 col-sm-4.5 col-md-4.5">
                <mat-form-field appearance="outline" class="w-100 background-white-field">
                  <mat-label>Attestation</mat-label>
                  <input matInput type="text" readonly [value]="calculRangeEndValue(input.value, item.attestation_range)">
                  <mat-hint>Intervalle</mat-hint>
                </mat-form-field>
              </div>

              <div class="col-12 col-sm-4.5 col-md-4.5">
                <mat-form-field appearance="outline" class="w-100 background-white-field">
                  <mat-label>Carte Rose</mat-label>
                  <input matInput type="text" readonly [value]="calculRangeEndValue(input.value, item.carte_rose_range)">
                  <mat-hint>Intervalle</mat-hint>
                </mat-form-field>
              </div>
            </div>

          </div>
        }
      </div>
    </div>

  </div>
</mat-dialog-content>

<mat-dialog-actions class="p-3 border-top bg-light m-0 d-flex align-items-center justify-content-between">
  <div class="d-flex align-items-center gap-2">
    <span class="small fw-semibold text-muted text-uppercase tracking-wider">Quantité Totale attribuée :</span>
    <span class="badge-total-qte">{{ currentQteSelected() }}</span>
  </div>
  <div class="d-flex gap-2">
    <button mat-stroked-button mat-dialog-close color="warn" class="px-4" (click)="resetForm()">Fermer</button>
    <button mat-flat-button color="primary" class="px-4" [disabled]="distForm.invalid || currentQteSelected() == 0 || err" (click)="onShare()">
      Enregistrer
    </button>
  </div>
</mat-dialog-actions>
